import React from "react";
import UploadedAttachmentList from "../UploadedAttachmentList";

const InlineAttachmentStatus = ({
  apiBase,
  attachmentType,
  pendingFiles = [],
  uploadedFiles = [],
  canEdit,
  canDeleteSavedAttachments = canEdit,
  isSaving,
  deletingFileId,
  onRemovePendingFile,
  onDeleteSavedAttachment,
}) => {
  const matchingPendingFiles = pendingFiles.filter(
    (entry) => entry.attachmentType === attachmentType,
  );
  const matchingFiles = uploadedFiles.filter(
    (file) => file.ta_type === attachmentType,
  );
  const matchingStagedFiles = matchingFiles.filter(
    (file) => Number(file.ta_pending) === 1,
  );
  const matchingUploadedFiles = matchingFiles.filter(
    (file) => Number(file.ta_pending) !== 1,
  );

  return (
    <div className="mt-3" data-inline-attachment-summary>
      <div className="fw-semibold mb-2">Attachments</div>

      {matchingPendingFiles.length > 0 && (
        <div className="p-3 bg-light rounded border">
          <div className="text-muted mb-2">Files Ready To Save</div>
          <ul className="list-unstyled mb-0">
            {matchingPendingFiles.map((entry, index) => (
              <li
                key={`${entry.file.name}_${entry.file.size}_${entry.file.lastModified}_${index}`}
                className="d-flex justify-content-between align-items-center gap-3 py-1"
              >
                <span className="text-break">{entry.file.name}</span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  data-delete-permission-exempt="true"
                  onClick={() => onRemovePendingFile(entry)}
                  disabled={!canEdit || isSaving}
                  title="Remove pending file"
                >
                  <i className="bi bi-trash" />
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <UploadedAttachmentList
        title="Pending Files (Save to confirm)"
        files={matchingStagedFiles}
        getFileKey={(file) => file.ta_id}
        getFileName={(file) => file.ta_original_name}
        getFileViewUrl={(file) =>
          `${apiBase}/api/custom-tasks/attachment-file/${file.ta_id}?mode=view`
        }
        getFileDownloadUrl={(file) =>
          `${apiBase}/api/custom-tasks/attachment-file/${file.ta_id}?mode=download`
        }
        canDelete={canDeleteSavedAttachments}
        deletePermissionExempt
        onDeleteFile={onDeleteSavedAttachment}
        deletingFileId={deletingFileId}
      />

      <UploadedAttachmentList
        title="Uploaded Files"
        files={matchingUploadedFiles}
        getFileKey={(file) => file.ta_id}
        getFileName={(file) => file.ta_original_name}
        getFileViewUrl={(file) =>
          `${apiBase}/api/custom-tasks/attachment-file/${file.ta_id}?mode=view`
        }
        getFileDownloadUrl={(file) =>
          `${apiBase}/api/custom-tasks/attachment-file/${file.ta_id}?mode=download`
        }
        canDelete={canDeleteSavedAttachments}
        deletePermissionExempt
        onDeleteFile={onDeleteSavedAttachment}
        deletingFileId={deletingFileId}
      />

      {!matchingPendingFiles.length &&
        !matchingStagedFiles.length &&
        !matchingUploadedFiles.length && (
        <div className="text-muted small border rounded bg-light p-3">
          No pending or uploaded attachments.
        </div>
      )}
    </div>
  );
};

export default InlineAttachmentStatus;
